import { atom } from 'recoil';

export const logoutModalState = atom<boolean>({
  key: 'logoutModalState',
  default: false,
});
